<template>
  <movable-area class="fixed-area" :style="{backgroundColor: backgroundColor}">
    <slot />
    <movable-view
      :animation="animate"
      :x="x"
      :y="y"
      @change="onChange"
      @click="backMiniProgram"
      class="ball"
      direction="all"
      v-if="show"
    >
      <view style="width: 30px; height: 30px">返回直播</view>
    </movable-view>
  </movable-area>
</template>

<script>
import jump from '@/utils/jump';
const TAG = 'global-return-ball';
// import { mapState } from 'vuex'
export default {
  data() {
    return {
      x: 300,
      y: 300,
      animate: false,
      show: false,
      old: {
        x: 0,
        y: 0,
      },
    };
  },
  props: {
    info: {
      type: Object,
      default() {
        return {};
      },
    },
    backgroundColor: String,
  },
  methods: {
    onTap(e) {
      jump.toLocation(e.currentTarget.dataset.item);
    },
    tap(e) {
      this.x = this.old.x;
      this.y = this.old.y;
      this.$nextTick(function () {
        this.x = 30;
        this.y = 30;
      });
    },
    onChange(e) {
      this.old.x = e.detail.x;
      this.old.y = e.detail.y;
    },
    backMiniProgram() {
      uni.navigateBackMiniProgram();
    },
    scrollPage(e) {
      const pages = getCurrentPages();
      const curPage = pages[pages.length - 1];
      if (curPage.myPageScroll) {
        curPage.myPageScroll(e);
      }
    },
    toBottom() {
      const pages = getCurrentPages();
      const curPage = pages[pages.length - 1];
      if (curPage.toBottom) {
        curPage.toBottom();
      }
    },
  },
};
</script>

<style scoped lang="scss" scoped>
@import '~@/styles/func.scss';
.fixed-area {
  width: 100%;
  height: 100vh;
}
.ball {
  position: fixed;
  background: #fff;
  box-shadow: 0 0 5px #ddd;
  border: #eee;
  width: 50px;
  height: 50px;
  text-align: center;
  z-index: 1002;
  border-radius: 50%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  word-wrap: break-word;
  font-size: 12px;
  color: #eb5352;
}
.close-area {
  position: fixed;
  width: 500rpx;
  height: 500rpx;
  right: -250rpx;
  bottom: -250rpx;
  background: #eb5352;
  border-radius: 50%;
  z-index: 1001;
}
.big {
  right: -230rpx;
  bottom: -230rpx;
}

.close-icon {
  height: 70rpx;
  width: 70rpx;
  position: absolute;
  top: 90rpx;
  left: 110rpx;
}
.close-text {
  position: absolute;
  top: 185rpx;
  left: 98rpx;
  font-size: 24rpx;
  color: #fff;
}
.return-icon {
  width: 40rpx;
  height: 40rpx;
  display: block;
  margin-bottom: 3rpx;
}
.return-text {
  color: #eb5352;
  font-size: 18rpx;
  display: block;
}
</style>
